import * as React from "react";
import { SVGProps } from "react";
const SvgCalculatorLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="44px"
    height="62px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0a5 5 0 0 0-5 5v52a5 5 0 0 0 5 5h34a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5H5ZM4 7a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7Zm32.848 28.547a3 3 0 0 1 3 3v16.32a3 3 0 0 1-3 3h-3.132a3 3 0 0 1-3-3v-16.32a3 3 0 0 1 3-3h3.132ZM7.151 22.32a3 3 0 0 0-3 3v3.093a3 3 0 0 0 3 3h3.132a3 3 0 0 0 3-3V25.32a3 3 0 0 0-3-3H7.151Zm-3 16.227a3 3 0 0 1 3-3h3.132a3 3 0 0 1 3 3v3.093a3 3 0 0 1-3 3H7.151a3 3 0 0 1-3-3v-3.093Zm3 10.226a3 3 0 0 0-3 3v3.094a3 3 0 0 0 3 3h3.132a3 3 0 0 0 3-3v-3.094a3 3 0 0 0-3-3H7.151ZM17.435 25.32a3 3 0 0 1 3-3h3.132a3 3 0 0 1 3 3v3.093a3 3 0 0 1-3 3h-3.132a3 3 0 0 1-3-3V25.32Zm3 10.227a3 3 0 0 0-3 3v3.093a3 3 0 0 0 3 3h3.132a3 3 0 0 0 3-3v-3.093a3 3 0 0 0-3-3h-3.132Zm-3 16.226a3 3 0 0 1 3-3h3.132a3 3 0 0 1 3 3v3.094a3 3 0 0 1-3 3h-3.132a3 3 0 0 1-3-3v-3.094ZM33.718 22.32a3 3 0 0 0-3 3v3.093a3 3 0 0 0 3 3h3.132a3 3 0 0 0 3-3V25.32a3 3 0 0 0-3-3h-3.132Z"
      fill="#095921"
    />
  </svg>
);
export default SvgCalculatorLg;
